import React, { useEffect, useRef, useState } from 'react'
import { cn } from '../utils/helpers'
import ArrowRight from '../assets/icons/AI/arrow.svg'

const content = {
  "en": {
    source: "Source"
  },
  "hi": {
    source: "स्रोत"
  }
}

const CardContent = (props) => {
  const { langCode = 'en', onLCPCardClick, userData, ...item } = props;
  switch (item.type) {
    case 'loading':
      return (
        <div className='px-3 py-1 flex items-center gap-2 text-sm text-black italic'>
          <span>Breasy is thinking</span>
          <span className='flex items-center gap-1' aria-hidden='true'>
            <span className='dot-flashing' />
          </span>
        </div>
      )
    case 'text':
      return <p className='text-sm text-black whitespace-pre-line break-words'>{item.text}</p>
    case 'card':
      const handleCardClick = () => {
        if (item.url && item.url.includes('http')) {
          let reactNativePayload = { action: "openURL", key: 204, url: item.url };
          window?.ReactNativeWebView?.postMessage(JSON.stringify(reactNativePayload));
          return;
        }
      }
      return (
        <div className='rounded-xl bg-bot-card/10 rounded-tl-none p-2.5'>
          <p className='text-base font-medium text-black whitespace-pre-line break-words'>{item.title}</p>
          <p className='text-sm text-black py-2 whitespace-pre-line break-words'>{item.description}</p>
          {
            item.url && item.url.includes('http') && (
              <button
                onClick={handleCardClick}
                className='text-xs font-light text-muted-foreground underline block w-full text-left break-all overflow-wrap-anywhere'
              >
                {item.url}
              </button>
            )
          }
          {/* {item?.source && item?.url && item?.url.includes('http') && <span className='text-xs font-light text-muted-foreground'>{content?.[langCode]?.source}: {item.source}</span>} */}
        </div>
      )
    case 'single-choice':
      const handleSingleChoice = (option) => {
        if (item.onSingleChoiceSelect) {
          item.onSingleChoiceSelect(option, item.chatId);
        }
      }
      return (
        <>
          <p className='text-sm text-black whitespace-pre-line break-words'>{item.title}</p>
          <div className='space-y-2.5 mt-2 w-full'>
            {item.options.map((option) => (
              <button
                key={option.value}
                onClick={() => handleSingleChoice(option)}
                className='button-style'
              >
                {option.label}
              </button>
            ))}
          </div>
        </>
      )
    case 'lcp-card':
      const handleLCPClick = () => {
        if (onLCPCardClick) {
          onLCPCardClick(item, userData);
        }
      };
      return (
        <div>
          <p className='text-sm text-black py-2.5 whitespace-pre-line break-words'>{item.description}</p>
          <div className='rounded-xl bg-bot-card/10 rounded-tl-none p-2.5'>
            <figure className='py-2.5'>
              <img src={item.icon} alt={item.title} className='w-full aspect-video object-cover rounded-2xl bg-foreground' />
            </figure>
            <button
              onClick={handleLCPClick}
              className='w-full button-gradient text-white rounded-lg px-4 py-3 font-bold flex items-center justify-center gap-3'
            >
              <span>{item.cta.text}</span>
              <img src={ArrowRight} alt="Arrow Right" />
            </button>
          </div>
        </div>
      )
    case 'redirection-card':
      const handleRedirection = () => {
        sessionStorage.setItem('triggerInitialMessage', 'true');
        if (item.navigate_url === 'health_checking_status') {
          let reactNativePayload = { type: "HANDLE_INTERNAL_SCREEN", key: 203, data: { ...item, navigate_url: 'health_check_in', navigate_from: 'chatbot' } };
          window?.ReactNativeWebView?.postMessage(JSON.stringify(reactNativePayload));
          return;
        } else {
          let reactNativePayload = { type: "HANDLE_INTERNAL_SCREEN", key: 203, data: { ...item, navigate_from: 'chatbot' } };
          window?.ReactNativeWebView?.postMessage(JSON.stringify(reactNativePayload));
        }
      }
      return (
        <button onClick={handleRedirection} className='overflow-hidden flex justify-start items-center gap-2 text-sm bg-bot-card/20 text-black rounded-xl px-2 py-1.5 border border-bot-card w-max text-left'>
          <img src={item?.icon} alt={item?.label} className='w-10 h-10 aspect-square object-cover rounded-full' />
          <div className='basis-11/12'>
            {item?.label && <p className='text-sm text-black whitespace-pre-line break-words font-medium text-left'>{item?.label}</p>}
            {item?.description && <p className='text-sm text-black whitespace-pre-line break-words'>{item?.description}</p>}
          </div>
          {item?.navigate_type === 'INTERNAL' && <span className='text-muted-foreground font-medium text-2xl flex justify-end'><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_79_1079)">
              <path d="M0.792893 12.7929C0.402369 13.1834 0.402369 13.8166 0.792893 14.2071C1.18342 14.5976 1.81658 14.5976 2.20711 14.2071L1.5 13.5L0.792893 12.7929ZM14.5 1.5C14.5 0.947715 14.0523 0.5 13.5 0.5H4.5C3.94772 0.5 3.5 0.947715 3.5 1.5C3.5 2.05228 3.94772 2.5 4.5 2.5H12.5V10.5C12.5 11.0523 12.9477 11.5 13.5 11.5C14.0523 11.5 14.5 11.0523 14.5 10.5V1.5ZM1.5 13.5L2.20711 14.2071L14.2071 2.20711L13.5 1.5L12.7929 0.792893L0.792893 12.7929L1.5 13.5Z" fill="#6E1EE5" />
            </g>
            <defs>
              <clipPath id="clip0_79_1079">
                <rect width="15" height="15" fill="white" />
              </clipPath>
            </defs>
          </svg>
          </span>}
        </button>
      )
    case 'event-card':
      return (
        <div className='border border-accent-foreground/10 rounded-lg overflow-hidden w-full'>
          <div className='flex justify-between items-center bg-foreground px-3 py-2 border-b border-border'>
            <figure className='rounded-full flex items-center justify-start gap-2'>
              <img src={item.image} alt={item.title} className='w-10 h-10 aspect-square object-cover rounded-full bg-muted-foreground' />
              <figcaption className='text-sm text-accent-foreground whitespace-pre-line font-medium'>{item.title}</figcaption>
            </figure>
            {
              item.badge && (
                <span className='text-sm text-white bg-black rounded-full px-2 py-1'>{item.badge}</span>
              )
            }
          </div>
          <div className='p-3 w-full'>
            {
              item.description && (
                <p className='text-sm text-accent-foreground font-medium whitespace-pre-line break-words'>{item.description}</p>
              )
            }
            <div className='flex items-center gap-2 w-full flex-wrap mt-3'>
              {
                item.cta.map((cta) => (
                  <button key={cta.text} className='bg-white border border-accent-foreground/10 text-black rounded-md px-4 py-2 w-fit'>{cta.text}</button>
                ))
              }
            </div>
          </div>
        </div>
      )
    case 'error':
      return <p className='text-sm text-red-500 break-words font-semibold'>{item.text}</p>
    default:
      return <p className='text-sm text-black whitespace-pre-line break-words'>{item?.text || item?.title || item?.description}</p>
  }
}


// Helper function to render chat content
const renderChatContent = (chat, chatIndex, onSingleChoiceSelect, onLCPCardClick, langCode = 'en', userData = null) => {
  // Determine which data to render
  const messages = chat?.data || chat?.messages;
  console.log("🚀 ~ renderChatContent ~ messages:", messages);
  const isArray = Array.isArray(messages);

  const chatId = chat.id || chatIndex;

  if (isArray) {
    return (
      <div className='space-y-3'>
        {messages?.map((msg, index) => (
          <CardContent
            key={`${chatId}-msg-${index}`}
            {...msg}
            onSingleChoiceSelect={onSingleChoiceSelect}
            onLCPCardClick={onLCPCardClick}
            chatId={chatId}
            langCode={langCode}
            userData={userData}
          />
        ))}
      </div>
    );
  }

  // Single message
  if (chat?.data) {
    return (
      <CardContent
        {...chat?.data}
        onSingleChoiceSelect={onSingleChoiceSelect}
        onLCPCardClick={onLCPCardClick}
        chatId={chatId}
        langCode={langCode}
        userData={userData}
      />
    );
  }

  return null;
};

const Chats = ({ response, isLoading, onSingleChoiceSelect, onLCPCardClick, userData, lastInputSource, langCode = 'en' }) => {
  const chatContainerRef = useRef(null);
  const bottomRef = useRef(null);
  const [autoScroll, setAutoScroll] = useState(true);
  const INPUT_AREA_HEIGHT = 155;

  const handleScroll = (event) => {
    const { scrollTop, scrollHeight, clientHeight } = event.currentTarget;
    const distanceFromBottom = scrollHeight - (scrollTop + clientHeight);
    setAutoScroll(distanceFromBottom <= 2);
  };

  useEffect(() => {
    if (!autoScroll) return;
    if (!bottomRef.current) return;

    const scroll = () => {
      bottomRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
    };

    const rafId = requestAnimationFrame(() => {
      scroll();
      setTimeout(scroll, 80);
      setTimeout(scroll, 160);
    });

    return () => cancelAnimationFrame(rafId);
  }, [response?.length, isLoading, autoScroll]);

  useEffect(() => {
    if (!autoScroll) return;
    const container = chatContainerRef.current;
    if (!container) return;

    const images = Array.from(container.querySelectorAll('img'));
    if (images.length === 0) return;

    let pending = images.length;

    const handleMediaLoad = () => {
      pending -= 1;
      if (pending <= 0) {
        requestAnimationFrame(() => {
          bottomRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
        });
      }
    };

    images.forEach((img) => {
      if (img.complete) {
        handleMediaLoad();
      } else {
        img.addEventListener('load', handleMediaLoad, { once: true });
        img.addEventListener('error', handleMediaLoad, { once: true });
      }
    });

    return () => {
      images.forEach((img) => {
        img.removeEventListener('load', handleMediaLoad);
        img.removeEventListener('error', handleMediaLoad);
      });
    };
  }, [response?.length, isLoading, autoScroll]);

  useEffect(() => {
    if (!autoScroll) return;
    const container = chatContainerRef.current;
    if (!container) return;

    const observer = new MutationObserver(() => {
      bottomRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
    });

    observer.observe(container, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [autoScroll]);

  return (
    <div className='mt-[64px] bg-background min-h-[calc(100vh-190px)] px-3 py-2'>
      <div
        ref={chatContainerRef}
        className='flex flex-col gap-3 overflow-y-auto bg-background'
        onScroll={handleScroll}
      >
        {response?.map((chat, chatIndex) => {
          const isAssistant = chat.role === 'assistant';
          const isUser = chat.role === 'user';
          const shouldAlignLeft = isAssistant || (!isUser && isLoading);

          return (
            <div
              key={chat.id || `chat-${chatIndex}`}
              className={cn(
                'items-center gap-2',
                shouldAlignLeft ? 'flex justify-start mr-7' : 'flex justify-end ml-7'
              )}
            >
              <div className={cn(
                'bg-transparent rounded-xl py-1.5 max-content',
                isAssistant ? 'bg-transparent rounded-tl-none' : 'bg-bot-card/10 rounded-tr-none px-2.5'
              )}>
                {renderChatContent(chat, chatIndex, onSingleChoiceSelect, onLCPCardClick, langCode, userData)}
              </div>
            </div>
          );
        })}
        {
          isLoading && (
            <div className={cn('items-center', isLoading ? 'flex justify-start' : 'flex justify-end')}>
              <div className={cn('flex items-start', isLoading ? 'flex-row' : 'flex-row-reverse')}>
                <div className={cn('bg-transparent py-1.5 w-full', isLoading ? 'bg-transparent rounded-tl-none' : 'bg-bot-card/10 rounded-tr-none')}>
                  <CardContent type='loading' />
                </div>
              </div>
            </div>
          )
        }
        <div ref={bottomRef} className='shrink-0 bg-background' style={{ height: INPUT_AREA_HEIGHT }} />
      </div>
    </div>
  )
}

export default Chats